import React, { Component } from 'react';
import {
  Row, Col, List, Button, Modal, Form, InputNumber,
} from 'antd';
import currencyFormatter from 'utils/currencyFormatter';
import { formPropType } from 'utils/propType';
import { FormControl, FormRules } from 'form-control';
import PropTypes from 'prop-types';
import autobind from 'react-autobind';
import translate from 'app/translations';
import { PROFILE_STEP_TYPES } from 'app/constants';
import AgentProfilePropType from '../AgentProfilePropType';
import WizardNav from './WizardNav';

import './Fees.scss';

const ListItem = List.Item;
const ListItemMeta = List.Item.Meta;

export class FeesComponent extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;
    this.state = {
      currentPage: 1,
      targetRecord: null,
      showModal: false,
    };
  }

  onNavigate(nextPage) {
    this.props.onSetAgentProfileStepRequest(nextPage);
  }

  handleSubmit(e) {
    if (e) e.preventDefault();
    const { form } = this.props;
    const { targetRecord } = this.state;

    form.validateFields((errors, values) => {
      if (!errors) {
        const { feeMap } = this.props.agentProfile.serviceGroupFees;
        const { id } = targetRecord;
        const { amount } = values;

        const payload = this.mapPayload(id, amount, feeMap);
        this.props.onSaveServiceFeeRequest(payload);
        this.closeModal();
      }
    });
  }

  mapPayload(id, amount, feeMap = {}) {
    const updatedFeeMap = {
      ...feeMap,
    };

    updatedFeeMap[id] = {
      serviceGroupId: id,
      amount: Number(amount || 0),
    };

    const payload = [];

    Object.keys(updatedFeeMap).forEach((serviceGroupId) => {
      payload.push({
        ...updatedFeeMap[serviceGroupId],
      });
    });

    return payload;
  }

  openModal(feeItem, serviceFee = {}) {
    this.setState({
      showModal: true,
      targetRecord: {
        ...feeItem,
        amount: serviceFee.amount,
      },
    });
  }

  closeModal(e) {
    if (e) e.preventDefault();
    this.setState({
      targetRecord: null,
      showModal: false,
    });
  }

  render() {
    const { form } = this.props;
    const { isCallInprogress } = this.props.agentProfile;
    const { feeMap } = this.props.agentProfile.serviceGroupFees;
    const { PROGRAM_SERVICE_GROUPS } = this.props.agentProfile.constants;
    const { showModal, targetRecord } = this.state;

    return (
      <div className="fees">
        <div className="card-container responsive-border">
          <div
            className="emphasized-text"
            style={{
              borderBottom: '1px solid #e8e8e8',
              paddingBottom: 12,
            }}
          >
            {this.t('Fees.info')}
          </div>

          <Row gutter={16}>
            <Col xs={24}>
              <List
                className="demo-loadmore-list"
                itemLayout="horizontal"
                dataSource={PROGRAM_SERVICE_GROUPS}
                renderItem={sgItem => (
                  <ListItem actions={[<Button size="small" type="primary" onClick={() => { this.openModal(sgItem, feeMap[sgItem.id]); }}>{this.t('Fees.update')}</Button>]}>
                    <ListItemMeta
                      title={<span>{sgItem.name}</span>}
                      description={sgItem.description}
                    />
                    <div>
                      {`${feeMap[sgItem.id] ? currencyFormatter(feeMap[sgItem.id].amount) : this.t('Fees.noFee')}`}
                    </div>
                  </ListItem>
                )}
                pagination={{
                  pageSize: 10,
                  current: this.state.currentPage,
                  onChange: n => this.setState({ currentPage: n }),
                }}
              />
            </Col>
          </Row>
        </div>
        <Modal
          title={this.t('Fees.updateFeeTitle')}
          visible={showModal}
          onOk={(e) => { this.handleSubmit(e); }}
          onCancel={(e) => { this.closeModal(e); }}
          okText={this.t('Generic.submit')}
          cancelText={this.t('Generic.cancel')}
          closable={false}
          maskClosable={false}
        >
          <Form layout="vertical">
            {targetRecord && (
              <div>
                <div><strong>{targetRecord.name}</strong></div>
                <div className="m-b-16">{targetRecord.description}</div>
                <div style={{ width: 150 }}>
                  <FormControl
                    form={form}
                    fieldName="amount"
                    displayName={this.t('Fees.fee')}
                    initialValue={targetRecord.amount || undefined}
                    rules={[FormRules.POSITIVEINT, { [FormRules.MAXNUMERIC]: [9000, '$', ''] }]}
                  >
                    <InputNumber
                      type="number"
                      className="currency-input closest-dollar"
                      autoComplete="off"
                      min={0}
                      step={1}
                      precision={0}
                    />
                  </FormControl>
                </div>
              </div>

            )}
          </Form>
        </Modal>
        <WizardNav
          agentProfile={this.props.agentProfile}
          isCallInProgress={isCallInprogress}
          currentPage={PROFILE_STEP_TYPES.FEES}
          onNavigate={this.onNavigate}
        />
      </div>
    );
  }
}

FeesComponent.propTypes = {
  form: PropTypes.shape(formPropType).isRequired,
  agentProfile: PropTypes.shape(AgentProfilePropType).isRequired,
  onSaveServiceFeeRequest: PropTypes.func.isRequired,
  onSetAgentProfileStepRequest: PropTypes.func.isRequired,
};

export default Form.create()(FeesComponent);
